/** Session bridge: Text Cleaner → Text Editor (avoids router state size limits). */
export const EDITOR_IMPORT_KEY = 'vorakit_text_editor_pending';

export function sendCleanedTextToEditor(content) {
  const str = String(content ?? '');
  try {
    sessionStorage.setItem(EDITOR_IMPORT_KEY, JSON.stringify({ content: str }));
  } catch (_) {
    try {
      sessionStorage.setItem(EDITOR_IMPORT_KEY, JSON.stringify({ content: str.slice(0, 2_000_000) }));
    } catch (__) {
      /* ignore */
    }
  }
}
